/**
 * PagePresence — shows avatar bubbles for other users currently viewing the page.
 * Thin wrapper around the shared PresenceAvatars component.
 */

import React from 'react';
import { PresenceAvatars } from '../../components/PresenceAvatars';

interface PagePresenceProps {
  readonly pageId: string;
}

export function PagePresence({ pageId }: PagePresenceProps): React.ReactElement | null {
  if (!pageId) return null;
  return <PresenceAvatars endpoint={`/v1/pages/${pageId}/viewers`} />;
}
